export const useNewsletterPopupStore = defineStore('newsletter-popup', () => {
  const isOpened = ref(false)
  const forceOpen = ref(false)
  const isBlockerOpened = ref(false)
  const allowPopupActivation = ref(false)

  function openPopup(force?: boolean) {
    const shouldOpen =
      force || (!isDisabledForNonSubscriber.value && allowPopupActivation.value)

    if (shouldOpen) {
      if (force) {
        // always open when forced by Toggle button regardless of other factors
        forceOpen.value = true
      }

      isOpened.value = true
      document.body.classList.add('subscription-is-open')
    }
  }

  function closePopup(shouldSetFormCookie?: boolean) {
    isOpened.value = false
    forceOpen.value = false

    document.body.classList.remove('subscription-is-open')
    if (shouldSetFormCookie) {
      setFormCookie()
    }
  }

  const cookie = useCookie('compass-subscription-non-subscriber', {
    path: '/',
    maxAge: 60 * 60 * 24 * 14, // 14 days
    sameSite: true,
  })

  const cookieSubscriber = useCookie('compass-subscription-subscriber', {
    path: '/',
    sameSite: true,
  })

  const isDisabledForNonSubscriber = computed(() => !!cookie.value || false)

  const isDisabledForSubscriber = computed(
    () => !!cookieSubscriber.value || false,
  )

  const setFormCookie = (subscriber?: boolean) => {
    // console.log('set cookie', subscriber)
    if (subscriber) {
      cookieSubscriber.value = 'active'
    } else {
      cookie.value = 'active'
    }
  }

  return {
    isOpened,
    forceOpen,
    isBlockerOpened,
    allowPopupActivation,
    isDisabledForNonSubscriber,
    isDisabledForSubscriber,
    openPopup,
    closePopup,
    setFormCookie,
  }
})
